import React from 'react'

import HeaderWidget from '../../../../../components/atoms/HeaderWidget'

const CompletionRate: React.FC = () => {
  return (
    <HeaderWidget
      title='Task Completion Rate'
      information='This metric measures the percentage of tasks completed before the due date. (if the due date is changed to a later time, this counts as a negative, or we can exclude it from the calculation) and Tasks that have a paused status are excluded.'
    >
      -
    </HeaderWidget>
  )
}

export default CompletionRate
